import { FC } from "react";

import { BUTTON_CLASSNAME } from "./constants";

export type SubmitFormElementProps = {
  submitTitle: string;
  disabled: boolean;
};

export const SubmitFormElement: FC<
  React.PropsWithChildren<SubmitFormElementProps>
> = ({ submitTitle, children, disabled }) => {
  return (
    <>
      {children}

      <input
        type="submit"
        value={submitTitle}
        disabled={disabled}
        className={BUTTON_CLASSNAME}
      />
    </>
  );
};
